import React, { Component } from "react";
import firebaseManager from "../../../../model/Firebase/FirebaseManager";
import { Redirect } from "react-router-dom";

class FacebookLogin extends Component {
  constructor() {
    super();
    this.state = {
      redirectToHome: false,
    };
  }

  signInWithGoogle = () => {
    firebaseManager.loginUserWithGmailTechnician(
      this.loginCallbackSuccess,
      this.loginCallbackFail
    );
  };

  loginCallbackSuccess = () => {
    this.setState({
      redirectToHome: true,
    });
  };
  loginCallbackFail(errMessage) {
    alert(errMessage);
  }
  render() {
    return (
      <div>
        <div className="text-center mt-2">
          {this.state.redirectToHome ? (
            <Redirect push to="/homeTechnician" />
          ) : null}
          <button
            className="btn btnGoogle mt-1 mx-auto"
            onClick={this.signInWithGoogle}
          >
            Sign in with Google
          </button>
        </div>
      </div>
    );
  }
}

export default FacebookLogin;
